import * as React from 'react';

import { Layout } from '../Layout';
import * as styles from './ControlsLayout.css';

export const ControlsLayout = ({ children }: React.PropsWithChildren) => {
  return (
    <Layout>
      <div className={styles['container']}>{children}</div>
    </Layout>
  );
};
